
export function HeroWithMarquee() {
  return (
    <div className="bg-background text-foreground flex items-center overflow-hidden relative py-16">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-8 items-center">
          <div>
            <h2 className="text-lg font-bold mb-2">
              The future is here
            </h2>
            <p className="text-muted-foreground">
              Built for traders, powered by Hedera.
            </p>
          </div>
      
        </div>
      </div>
    </div>
  );
}


